export default __webpack_public_path__ + "static/media/about_me_pins_and_stickers_header.8b42b0e0.png";